var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13.697a1 1 0 0 1 .168-.554l5.059-7.588A1 1 0 0 0 18.395 4H5.605a1 1 0 0 0-.831 1.555l5.058 7.588a1 1 0 0 1 .168.554v5.89a1 1 0 0 0 1.53.848l2-1.25a1 1 0 0 0 .47-.848v-4.64Zm2 .606a1 1 0 0 1 .168-.555l4.723-7.084C22.22 4.67 20.79 2 18.395 2H5.605C3.21 2 1.78 4.67 3.11 6.664l4.723 7.084a1 1 0 0 1 .168.555v5.284c0 2.357 2.592 3.793 4.59 2.544l2-1.25A3 3 0 0 0 16 18.337v-4.034Z",
    fill: "#777E91"
  })));
};
export default SvgLine;